import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetExternalAccountByProvider } from '../selectors/external-accounts';

import { fetchExternalAccounts } from '../actions/external-accounts';

import { logout } from '../globals-service';
import { getExternalAccountOptions, getOAuthStateParam } from '../services/external-accounts-service';

import ModalDefault from '../modals/modal-default';
import GoogleLogin from './google-login';
import MicrosoftLogin from './MicrosoftLogin';
import UserSSOSettings from './UserSSOSettings';

import IconGoogle from '../icons/icon-google';

class UserLinkSSO extends PureComponent {
    handleCancelClick = () => {
        this.props.onCancel && this.props.onCancel();
    }

    componentDidMount() {
        fetchExternalAccounts();
    }

    render() {
        const { googleAccount, microsoftAccount, ssoPolicy, t } = this.props;

        return (
            <div className="modal-wrap">
                <div className="modal-wrap-inner">
                    <ModalDefault
                        size="xsmall"
                        title={ t('onboarding:Authorize account') }
                        content={
                            <div className="user-link-sso">
                                <p>{ t('ssoOnly.description') }</p>

                                <h4>1. { t('ssoOnly.steps.link') }</h4>

                                <UserSSOSettings
                                    withTitle={false}
                                    showGoogle={['google', 'any_sso'].includes(ssoPolicy)}
                                    showMicrosoft={['microsoft', 'any_sso'].includes(ssoPolicy)}
                                />

                                <h4>2. { t('ssoOnly.steps.login') }</h4>

                                {
                                    ['google', 'any_sso'].includes(ssoPolicy) ? (
                                        <p>
                                            <GoogleLogin disabled={!googleAccount} />
                                        </p>
                                    ) : null
                                }

                                {
                                    ['microsoft', 'any_sso'].includes(ssoPolicy) ? (
                                        <p>
                                            <MicrosoftLogin disabled={!microsoftAccount} />
                                        </p>
                                    ) : null
                                }
                            </div>
                        }
                        actions={
                            <React.Fragment>
                                <button className="btn btn-caution" onClick={this.handleCancelClick}>{ t('common:Cancel') }</button>
                            </React.Fragment>
                        }
                    />
                </div>
            </div>
        )
    }
}

const makeMapStateToProps = () => {
    const getGoogleAccount = makeGetExternalAccountByProvider();
    const getMicrosoftAccount = makeGetExternalAccountByProvider();

    return ({ externalAccounts }, ownProps) => ({
        googleAccount: getGoogleAccount(externalAccounts.items, 'google', false),
        microsoftAccount: getMicrosoftAccount(externalAccounts.items, 'microsoft', false)
    });
}

export default connect(makeMapStateToProps)(withTranslation(['apps', 'onboarding', 'common'])(UserLinkSSO));
